import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Guy() {
  const firstBall = useRef();
  const secondBall = useRef();
  const thirdBall = useRef();

  useEffect(() => {
    gsap.to(firstBall.current, {
      rotation: "360",
      repeat: "-1",
      duration: "3",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(secondBall.current, {
      y: "45",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(thirdBall.current, {
      rotation: "-180",
      repeat: "-1",
      duration: "2",
      ease: "power4",
      yoyoEase: true,
      yoyo: true,
    });
  });

  return (
    <>
      <svg
        width="600"
        height="600"
        viewBox="0 0 927 786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="guy"
      >
        <g id="undraw_lost_online_re_upmy 1" clipPath="url(#clip0_0_1)">
          <path
            id="Vector"
            d="M894.203 329.056C847.863 388.316 760.422 401.886 688.073 381.246C664.4 374.328 641.562 364.821 619.973 352.896C607.433 346.086 595.193 338.616 583.203 330.656C580.253 328.706 577.303 326.726 574.383 324.706C572.393 323.346 570.409 321.97 568.433 320.576C543.672 303.156 519.883 284.046 496.493 265.046C438.103 217.616 378.113 168.726 306.373 146.096C291.593 141.436 272.473 139.256 263.333 151.776C255.403 162.646 260.243 178.036 266.953 189.696C291.843 232.886 337.023 260.156 382.243 281.126C427.462 302.096 475.363 319.086 514.672 349.746C553.982 380.406 583.993 429.136 575.953 478.326C569.023 520.716 534.413 555.156 494.172 570.166C453.933 585.166 409.053 583.076 367.223 573.336C325.393 563.586 285.683 546.576 245.313 531.916C220.973 523.066 189.153 516.946 173.003 537.196C159.363 554.306 167.203 581.296 183.813 595.536C200.422 609.776 222.903 614.546 244.353 618.826C310.953 632.126 377.553 645.423 444.153 658.716C464.583 662.786 485.493 667.046 503.293 677.886C521.093 688.716 535.453 707.636 534.943 728.466C534.433 748.996 519.403 767.136 500.982 776.226C482.573 785.306 461.313 786.706 440.803 785.726C363.943 782.046 143.593 659.936 90.7427 644.326C56.7827 634.306 19.6529 619.586 5.33255 587.206C-12.4975 546.896 16.8428 498.126 56.8926 479.716C96.9326 461.296 143.353 465.376 186.993 471.576C230.633 477.776 275.712 485.666 318.193 473.886C360.672 462.106 399.593 423.706 395.403 379.826C391.752 341.646 357.363 312.876 321.172 300.196C292.843 290.266 262.703 287.566 232.943 283.096C224.683 281.866 216.453 280.486 208.303 278.786C187.431 274.413 167.071 267.878 147.553 259.286C127.071 250.29 107.613 239.122 89.5128 225.976C75.076 215.507 61.5845 203.792 49.193 190.966C47.3028 189.006 45.4327 187.003 43.5826 184.956C41.8229 182.996 40.0826 180.996 38.3829 178.956C16.2628 152.526 -0.0775409 119.976 4.82285 86.4364C9.7125 52.9864 35.7828 25.1364 66.8228 11.7564C84.7628 4.02643 104.113 0.566423 123.703 0.0664231C138.027 -0.219855 152.347 0.811151 166.483 3.14643C231.893 13.6064 291.833 45.3865 348.443 79.7964C405.043 114.206 460.203 151.976 521.733 176.506C583.263 201.046 653.303 211.436 715.723 189.246C778.143 167.066 829.422 106.546 826.373 40.3764C867.773 76.0264 902.953 120.836 918.533 173.196C934.113 225.556 927.853 286.016 894.203 329.056Z"
            fill="#3F3D56"
          />
          <path
            id="greenball"
            d="M595.911 260.671C599.93 260.671 603.188 257.413 603.188 253.394C603.188 249.374 599.93 246.116 595.911 246.116C591.891 246.116 588.633 249.374 588.633 253.394C588.633 257.413 591.891 260.671 595.911 260.671Z"
            fill="#39FF14"
            ref={firstBall}
          />
          <path
            id="greenball_2"
            d="M852.911 168.646C859.125 168.646 864.163 163.608 864.163 157.394C864.163 151.179 859.125 146.142 852.911 146.142C846.696 146.142 841.659 151.179 841.659 157.394C841.659 163.608 846.696 168.646 852.911 168.646Z"
            fill="#39FF14"
            ref={secondBall}
          />
          <path
            id="greenball_3"
            d="M114.911 515.551C117.207 515.551 119.068 513.69 119.068 511.394C119.068 509.098 117.207 507.236 114.911 507.236C112.615 507.236 110.753 509.098 110.753 511.394C110.753 513.69 112.615 515.551 114.911 515.551Z"
            fill="#39FF14"
            ref={thirdBall}
          />
          <path
            id="Vector_2"
            d="M234.243 272.396C234.245 276.002 233.809 279.596 232.943 283.096C224.683 281.866 216.453 280.486 208.303 278.786C187.431 274.413 167.071 267.878 147.553 259.286C150.692 249.152 157.36 240.48 166.347 234.843C175.335 229.206 186.045 226.978 196.535 228.565C207.025 230.151 216.598 235.446 223.517 243.488C230.435 251.531 234.241 261.787 234.243 272.396Z"
            fill="#39FF14"
          />
          <path
            id="Vector_3"
            d="M780.911 234.646C783.259 234.646 785.163 232.742 785.163 230.394C785.163 228.045 783.259 226.142 780.911 226.142C778.562 226.142 776.659 228.045 776.659 230.394C776.659 232.742 778.562 234.646 780.911 234.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_4"
            d="M391.911 702.646C394.259 702.646 396.163 700.742 396.163 698.394C396.163 696.045 394.259 694.142 391.911 694.142C389.562 694.142 387.659 696.045 387.659 698.394C387.659 700.742 389.562 702.646 391.911 702.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_5"
            d="M452.911 761.646C455.259 761.646 457.163 759.742 457.163 757.394C457.163 755.045 455.259 753.142 452.911 753.142C450.562 753.142 448.659 755.045 448.659 757.394C448.659 759.742 450.562 761.646 452.911 761.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_6"
            d="M75.9107 593.646C78.259 593.646 80.1627 591.742 80.1627 589.394C80.1627 587.045 78.259 585.142 75.9107 585.142C73.5624 585.142 71.6588 587.045 71.6588 589.394C71.6588 591.742 73.5624 593.646 75.9107 593.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_7"
            d="M284.911 514.646C287.259 514.646 289.163 512.742 289.163 510.394C289.163 508.045 287.259 506.142 284.911 506.142C282.562 506.142 280.659 508.045 280.659 510.394C280.659 512.742 282.562 514.646 284.911 514.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_8"
            d="M263.911 92.6457C266.259 92.6457 268.163 90.7421 268.163 88.3938C268.163 86.0455 266.259 84.1418 263.911 84.1418C261.562 84.1418 259.659 86.0455 259.659 88.3938C259.659 90.7421 261.562 92.6457 263.911 92.6457Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_9"
            d="M520.911 425.646C523.259 425.646 525.163 423.742 525.163 421.394C525.163 419.045 523.259 417.142 520.911 417.142C518.562 417.142 516.659 419.045 516.659 421.394C516.659 423.742 518.562 425.646 520.911 425.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_10"
            d="M552.911 499.646C555.259 499.646 557.163 497.742 557.163 495.394C557.163 493.045 555.259 491.142 552.911 491.142C550.562 491.142 548.659 493.045 548.659 495.394C548.659 497.742 550.562 499.646 552.911 499.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_11"
            d="M169.643 101.966C169.674 123.435 164.601 144.603 154.843 163.726C153.553 166.246 152.186 168.723 150.743 171.156C136.453 195.289 115.072 214.431 89.5128 225.976C75.076 215.506 61.5845 203.792 49.193 190.966C47.3028 189.006 45.4327 187.003 43.5826 184.956C41.8228 182.996 40.0826 180.996 38.3829 178.956C16.2628 152.526 -0.0775533 119.976 4.82284 86.4363C9.71249 52.9863 35.7828 25.1362 66.8228 11.7562C84.7628 4.02623 104.113 0.566284 123.703 0.0662842C139.02 13.5933 151.095 30.3955 159.033 49.2263C160.033 51.5963 160.953 53.9963 161.823 56.4263C167.013 71.0479 169.658 86.4509 169.643 101.966Z"
            fill="#39FF14"
          />
          <path
            id="Vector_12"
            d="M231.643 108.966C231.643 129.796 211.303 149.116 174.363 163.386C166.973 166.246 159.063 168.836 150.743 171.156C119.603 179.836 82.5426 184.646 43.5826 184.956C41.8228 182.996 40.0826 180.996 38.3829 178.956C38.8028 178.966 39.2227 178.966 39.6427 178.966C81.9527 178.966 122.093 173.606 154.843 163.726C160.893 161.896 166.693 159.916 172.203 157.786C206.163 144.676 225.643 126.876 225.643 108.966C225.643 91.0562 206.163 73.2662 172.203 60.1462C168.843 58.8462 165.383 57.6062 161.823 56.4262C160.953 53.9962 160.033 51.5962 159.033 49.2262C164.353 50.8862 169.463 52.6596 174.363 54.5462C211.303 68.8162 231.643 88.1462 231.643 108.966Z"
            fill="#E4E4E4"
          />
          <path
            id="Vector_13"
            d="M45.9107 34.6457C48.259 34.6457 50.1627 32.7421 50.1627 30.3938C50.1627 28.0455 48.259 26.1418 45.9107 26.1418C43.5624 26.1418 41.6588 28.0455 41.6588 30.3938C41.6588 32.7421 43.5624 34.6457 45.9107 34.6457Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_14"
            d="M134.911 61.6457C137.259 61.6457 139.163 59.7421 139.163 57.3938C139.163 55.0455 137.259 53.1418 134.911 53.1418C132.562 53.1418 130.659 55.0455 130.659 57.3938C130.659 59.7421 132.562 61.6457 134.911 61.6457Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_15"
            d="M88.9107 141.742C111.747 141.742 130.259 123.23 130.259 100.394C130.259 77.5576 111.747 59.0453 88.9107 59.0453C66.0746 59.0453 47.5623 77.5576 47.5623 100.394C47.5623 123.23 66.0746 141.742 88.9107 141.742Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_16"
            opacity="0.3"
            d="M852.513 319.236C843.233 321.976 822.773 323.996 800.273 325.236C777.783 326.466 753.113 327.006 728.753 327.526C686.113 328.446 643.476 329.37 600.843 330.296C594.983 330.426 589.102 330.546 583.203 330.656C580.253 328.706 577.303 326.726 574.383 324.706C579.613 324.736 584.843 324.706 590.033 324.606C612.203 324.166 630.973 322.436 652.353 321.616C685.253 320.346 720.773 321.346 755.063 321.856C789.353 322.376 828.422 322.186 852.513 319.236Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_17"
            opacity="0.3"
            d="M198.084 634.467L62.1627 521.236L194.208 639.002C194.463 639.433 194.818 639.797 195.242 640.063C195.667 640.329 196.148 640.49 196.647 640.533C197.146 640.576 197.648 640.499 198.112 640.31C198.575 640.12 198.987 639.822 199.312 639.441C199.638 639.06 199.868 638.607 199.983 638.12C200.099 637.633 200.096 637.125 199.976 636.638C199.856 636.152 199.622 635.701 199.292 635.324C198.963 634.946 198.549 634.652 198.084 634.467H198.084Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_18"
            d="M94.9107 205.646C97.259 205.646 99.1627 203.742 99.1627 201.394C99.1627 199.045 97.259 197.142 94.9107 197.142C92.5624 197.142 90.6588 199.045 90.6588 201.394C90.6588 203.742 92.5624 205.646 94.9107 205.646Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_19"
            d="M452.017 694.074L469.604 694.073L477.971 626.236L452.014 626.237L452.017 694.074Z"
            fill="#B06C49"
          />
          <path
            id="Vector_20"
            d="M447.531 688.332L452.481 688.331L471.808 680.472L482.166 688.33H482.168C488.022 688.331 493.636 690.656 497.775 694.795C501.914 698.935 504.24 704.549 504.24 710.402V711.12L447.532 711.122L447.531 688.332Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_21"
            d="M320.308 694.074L302.721 694.073L294.354 626.236L320.311 626.237L320.308 694.074Z"
            fill="#B06C49"
          />
          <path
            id="Vector_22"
            d="M324.794 711.122L268.085 711.12V710.402C268.085 704.549 270.411 698.935 274.55 694.795C278.69 690.656 284.304 688.331 290.158 688.33H290.159L300.517 680.472L319.844 688.331L324.795 688.332L324.794 711.122Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_23"
            d="M383.325 174.188L365.517 187.748L318.212 200.276C318.212 200.276 335.163 319.236 327.163 327.236C319.163 335.236 326.378 335.451 324.77 345.844C323.163 356.236 316.757 383.674 316.757 383.674H457.945C457.945 383.674 459.082 366.622 452.122 362.929C445.163 359.236 458.538 342 452.85 339.118C447.163 336.236 455.163 311.236 455.163 311.236L472.5 229.387L426.386 193.307L419.373 176.409L383.325 174.188Z"
            fill="#39FF14"
          />
          <path
            id="Vector_24"
            d="M405.545 280.49C408.948 280.49 411.707 277.731 411.707 274.328C411.707 270.926 408.948 268.167 405.545 268.167C402.142 268.167 399.384 270.926 399.384 274.328C399.384 277.731 402.142 280.49 405.545 280.49Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_25"
            d="M316.757 383.674L310.935 533.595C310.935 533.595 285.796 644.325 290.163 647.236C294.529 650.147 296.379 667.505 296.379 667.505L321.123 670.416C321.123 670.416 321.123 658.772 326.946 654.405C332.768 650.039 386.623 444.807 386.623 444.807L439.163 643.236C439.163 643.236 440.478 654.406 444.845 654.406C449.211 654.406 450.667 670.417 450.667 670.417H475.411V654.406C475.411 654.406 486.529 650.881 482.163 639.236C477.796 627.592 457.945 383.674 457.945 383.674H316.757Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_26"
            d="M401.817 165.254C418.297 165.254 431.656 151.895 431.656 135.415C431.656 118.936 418.297 105.577 401.817 105.577C385.338 105.577 371.979 118.936 371.979 135.415C371.979 151.895 385.338 165.254 401.817 165.254Z"
            fill="#B06C49"
          />
          <path
            id="Vector_27"
            opacity="0.1"
            d="M452.85 269.414L458.672 273.781L461.583 253.403L452.85 269.414Z"
            fill="black"
          />
          <path
            id="Vector_28"
            d="M321.003 200.16C321.003 200.16 313.725 198.705 309.358 211.804C304.992 224.904 288.981 274.393 288.981 283.126C288.981 291.859 388.691 330.393 388.691 330.393L378.316 293.997L332.647 270.026L321.003 200.16Z"
            fill="#39FF14"
          />
          <path
            id="Vector_29"
            d="M393.316 324.997C402.705 324.997 410.316 317.386 410.316 307.997C410.316 298.608 402.705 290.997 393.316 290.997C383.927 290.997 376.316 298.608 376.316 307.997C376.316 317.386 383.927 324.997 393.316 324.997Z"
            fill="#B06C49"
          />
          <path
            id="Vector_30"
            opacity="0.1"
            d="M331.316 251.997L332.647 270.026L374.878 292.192L337.316 266.997L331.316 251.997Z"
            fill="black"
          />
          <path
            id="Vector_31"
            d="M432.839 254.567H432.291V239.559C432.291 238.418 432.067 237.289 431.63 236.235C431.194 235.181 430.554 234.223 429.747 233.417C428.941 232.61 427.983 231.97 426.929 231.534C425.875 231.097 424.746 230.873 423.605 230.873H391.808C390.667 230.873 389.538 231.097 388.484 231.534C387.43 231.97 386.472 232.61 385.666 233.417C384.859 234.223 384.219 235.181 383.783 236.235C383.346 237.289 383.122 238.418 383.122 239.559V321.896C383.122 323.036 383.346 324.166 383.783 325.22C384.219 326.274 384.859 327.231 385.666 328.038C386.472 328.844 387.43 329.484 388.484 329.921C389.538 330.357 390.667 330.582 391.808 330.582H423.605C424.746 330.582 425.875 330.357 426.929 329.921C427.983 329.484 428.941 328.844 429.747 328.038C430.554 327.231 431.194 326.274 431.63 325.22C432.067 324.166 432.291 323.036 432.291 321.896V265.25H432.839V254.567Z"
            fill="#F0F0F0"
          />
          <path
            id="Vector_32"
            d="M472.5 229.387C472.5 229.387 476.867 232.298 479.778 245.398C482.689 258.498 501.611 307.986 494.333 319.63C487.055 331.275 484.907 343.703 460.163 326.236L425.923 294.886L450.667 271.598L460.856 278.875L472.5 229.387Z"
            fill="#39FF14"
          />
          <path
            id="Vector_33"
            d="M408.095 267.57C412.114 267.57 415.373 264.312 415.373 260.292C415.373 256.273 412.114 253.015 408.095 253.015C404.076 253.015 400.817 256.273 400.817 260.292C400.817 264.312 404.076 267.57 408.095 267.57Z"
            fill="#39FF14"
          />
          <path
            id="Vector_34"
            d="M429.163 293.236C438.552 293.236 446.163 285.625 446.163 276.236C446.163 266.847 438.552 259.236 429.163 259.236C419.774 259.236 412.163 266.847 412.163 276.236C412.163 285.625 419.774 293.236 429.163 293.236Z"
            fill="#B06C49"
          />
          <path
            id="Vector_35"
            opacity="0.1"
            d="M330.514 306.41L379.316 327.997L329.158 318.194L330.514 306.41Z"
            fill="black"
          />
          <path
            id="Vector_36"
            d="M371.713 141.362L367.617 125.77C366.548 121.702 365.47 117.551 365.71 113.352C365.95 109.152 367.731 104.819 371.269 102.543C374.807 100.268 380.208 100.806 382.485 104.343C382.918 98.6951 388.055 94.3509 393.507 92.8119C398.958 91.2729 404.745 91.8815 410.404 92.1412C416.062 92.4008 422.035 92.2196 426.918 89.3499C427.29 90.4664 427.266 91.6772 426.849 92.7779C426.432 93.8785 425.648 94.8015 424.629 95.3911C425.843 95.7224 427.138 95.5801 428.251 94.9931C429.364 94.406 430.212 93.4181 430.624 92.2291C430.661 95.5 429.453 98.6624 427.243 101.074C429.351 100.029 431.772 99.8049 434.035 100.446C436.299 101.087 438.243 102.547 439.489 104.542C441.981 108.863 440.585 114.289 439.127 119.059L431.643 143.542C430.508 139.82 430.294 135.891 429.687 132.047C429.08 128.204 428 124.279 425.463 121.329C422.926 118.379 418.616 116.671 415.012 118.135C412.989 118.957 411.447 120.625 409.621 121.821C405.875 124.276 401.109 124.628 396.658 124.129C392.207 123.629 387.869 122.362 383.418 121.855C380.632 121.538 377.522 121.622 375.419 123.478C373.973 124.981 373.018 126.888 372.681 128.946C371.689 133.048 371.298 137.272 371.523 141.486"
            fill="#2F2E41"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="926.632" height="785.994" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export default Guy;
